
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LandingLabel extends Vue {
  @Prop({ default: '' }) labelText!: string;
  @Prop({ default: '' }) labelFolder!: string;
}
